export default __webpack_public_path__ + "static/media/logout.94b3f11b.svg";